import { UserRole } from "@/types";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from "@mui/material";
import { FC, useState } from "react";
import { useListContext } from "react-admin";
import { z } from "zod";
import { PaymentsFilterProps } from "./payments-filter.types";
import {
  PaymentsFilterRole,
  PaymentsListFilter,
} from "@/features/affiliate-payouts/types.ts";

const initialFormState = {
  roles: [],
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const formSchema = z.object({
  roles: z.array(z.nativeEnum(PaymentsFilterRole)),
});

type FormData = z.infer<typeof formSchema>;

const PaymentsFilter: FC<PaymentsFilterProps> = ({ onModalClose }) => {
  const [filtersFormData, setFiltersFormData] = useState<Partial<FormData>>({});

  const { filterValues, setFilters } = useListContext();

  const formData: FormData = {
    roles:
      filtersFormData.roles ?? filterValues.roles ?? initialFormState.roles,
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    field: "roles"
  ) => {
    const checked = event.target.checked;
    const fieldValue = event.target.name as UserRole;

    let currentArray = formData[field] ? [...formData[field]!] : [];

    if (checked) {
      if (!currentArray.includes(fieldValue)) {
        currentArray.push(fieldValue);
      }
    } else {
      currentArray = currentArray.filter((v) => v !== fieldValue);
    }

    setFiltersFormData({ ...formData, [field]: currentArray });
  };

  const onSubmit = () => {
    const filters: Pick<PaymentsListFilter, "roles"> = {
      roles: formData.roles.length ? formData.roles : undefined,
    };

    setFilters({ ...filterValues, ...filters });
    onModalClose();
  };

  return (
    <Stack spacing={2}>
      <Divider sx={{ borderColor: "#333" }} />

      <FormGroup>
        <Typography variant="h6" align="left">
          Role
        </Typography>
        <FormControlLabel
          name={PaymentsFilterRole.MUSE}
          label={"Woman"}
          labelPlacement="start"
          sx={{ ml: 0, justifyContent: "space-between" }}
          control={
            <Checkbox
              checked={formData.roles.includes(PaymentsFilterRole.MUSE)}
              onChange={(e) => handleCheckboxChange(e, "roles")}
            />
          }
        />
        <FormControlLabel
          name={PaymentsFilterRole.ALPHA}
          label={"Man"}
          labelPlacement="start"
          sx={{ ml: 0, justifyContent: "space-between" }}
          control={
            <Checkbox
              checked={formData.roles.includes(PaymentsFilterRole.ALPHA)}
              onChange={(e) => handleCheckboxChange(e, "roles")}
            />
          }
        />
        <FormControlLabel
          name={PaymentsFilterRole.Affiliate}
          label={"Affiliate"}
          labelPlacement="start"
          sx={{ ml: 0, justifyContent: "space-between" }}
          control={
            <Checkbox
              checked={formData.roles.includes(PaymentsFilterRole.Affiliate)}
              onChange={(e) => handleCheckboxChange(e, "roles")}
            />
          }
        />
      </FormGroup>

      <Divider sx={{ borderColor: "#333" }} />

      <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setFiltersFormData(initialFormState);
          }}
        >
          Reset
        </Button>

        <Stack direction={"row"} spacing={2}>
          <Button variant="outlined" onClick={onModalClose}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" onClick={onSubmit}>
            Filter
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
};

export { PaymentsFilter };
